import twitter from 'twitter-text'

import type { FacebookMentionDbEntry } from '~publish/legacy/editor/plugins/facebook-mention/nodes'
import { isNotNull } from '~publish/legacy/utils/isNotNull'

import { concatMentionsToEntities } from '../common'
import type { MentionEntity } from '../common'

export const getFacebookMentions = (
  fbEntities?: FacebookMentionDbEntry[] | null,
): MentionEntity[] | null => {
  if (!fbEntities || fbEntities.length === 0) return null

  return fbEntities.map((entity) => ({
    displayString: entity.text,
    indices: entity.indices,
    rawString: entity.text,
    url: entity.url,
  }))
}

const getEntities = (
  entities: MentionEntity[],
  fbEntities?: FacebookMentionDbEntry[] | null,
): MentionEntity[] => {
  const mentions = getFacebookMentions(fbEntities)

  return concatMentionsToEntities(mentions, entities)
}

function isOverlappingAnnotation(
  [start, end]: [number, number],
  fbEntities: FacebookMentionDbEntry[],
): boolean {
  return fbEntities.some((entity) => {
    const [entityStart, entityEnd] = entity.indices

    return start < entityEnd && entityStart < end
  })
}

export const parseFacebookLinks = (
  text?: string | null,
  fbEntities?: FacebookMentionDbEntry[] | null,
): MentionEntity[] => {
  const entities = text
    ? twitter
        .extractEntitiesWithIndices(text)
        .map((entity) => {
          // Skip URLs and hashtags that overlap with Facebook entity annotations (page mentions)
          if (
            fbEntities &&
            isOverlappingAnnotation(entity.indices, fbEntities)
          ) {
            return null
          }

          if ('url' in entity && entity.url) {
            return {
              displayString: entity.url,
              indices: entity.indices,
              rawString: entity.url,
              url: entity.url,
            }
          }
          if ('hashtag' in entity && entity.hashtag) {
            return {
              displayString: `#${entity.hashtag}`,
              indices: entity.indices,
              rawString: `#${entity.hashtag}`,
            }
          }
          return null
        })
        .filter(isNotNull)
    : []

  return getEntities(entities, fbEntities)
}
